export const QUERY_KEYS = {
  currentUser: "currentUser",
  getProjects:"getProjects",
  getProjectDetails:"getProjectDetails",
  organisation:"organisation",
  taskById:"taskById",
  taskMamber:"taskMamber",
  allTask:"allTask",
  myTasks: "myTasks",
  allNotification:"allNotification",
  notificationHistory: "notificationHistory",
  allKanbanColumn:"allKanbanColumn",
  ProjectMember:"getProjectMembers",
  DemoProject:"getDemoProject",
  getLocation:"getLocation",
  paymentStatus:"paymentStatus",
  paymentInvoice:"paymentInvoice",
  paymentsubscription:"subscription",
  paymentInvoicePortal:"paymentInvoicePortal",
  risk:"risk",
  demoRisk:"demoRisk",
  ribbon:"ribbon",
  setting:"setting",
  portfolios:"portfolios",
  allToken:"allToken",
  collaboratorVerificationToken:"collaboratorVerificationToken",
  getAvailabilityByUserID:"getAvailabilityByUserID",
  getProjectsNocal:"getProjectsNocal",
  getAllAvailability:"getAllAvailability",
  getAllAbsentType:"getAllAbsentType",
  dashboardStatusSummary:"dashboardStatusSummary",
  dashboardPortfolioProgress:"dashboardPortfolioProgress",
  dashboardProjectPerformance:"dashboardProjectPerformance",
  portfolioDashboard:"portfolioDashboard",
  timesheet: "timesheet",
  timesheetPeriod: "timesheetPeriod",
  timesheetPending: "timesheetPending",
  timesheetSidebarCounts: "timesheetSidebarCounts",
  timesheetPeriodReview: "timesheetPeriodReview",
  jobTitles: "jobTitles",
  contractTypes: "contractTypes",
  teamUnits: "teamUnits",
  projectSummary: "projectSummary",
  projectPerformance: "projectPerformance",
  projectAlerts: "projectAlerts",
  projectHighlights: "projectHighlights",
  workstreams: "workstreams",
  projectTypes: "projectTypes",
  projectPhases: "projectPhases",
  projectPriorities: "projectPriorities",
  projectCategories: "projectCategories",
  nonLaborCostTypes: "nonLaborCostTypes",
  nonLaborCosts: "nonLaborCosts",
  dashboardPortfolioCapacity: "dashboardPortfolioCapacity",
} as const;
